window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
 */
site.GSAPAnims = (function GSAPAnims() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;
  let scroll = null;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    // Detect css-grid un-supported
    const el = document.createElement("div")
    const supportsGrid = "string" == typeof el.style.grid;
    if(!supportsGrid) {
      document.querySelector('body').classList.add('is-ie-11');
      return false;
    }

    if ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      || window.innerWidth <= 1024) {
      document.querySelector('body').classList.add('is-ie-11');
      return false;
    }

    // IE 11 || Old Browser - Ignore zone

    inited = true;

    setTimeout(function() {

      console.log('Start of Anims();');

      document.querySelector('body').classList.add('dom-loaded', 'is-animated');

      gsap.defaults({ ease: Expo.easeOut, duration: 0.5 });

      if (document.querySelector('body').classList.contains('homepage')) {
        const tl = gsap.timeline();
        tl
          .to(".block-hero .hero-container", { y: '-50%', opacity: 1 })
          .to(".block-hero .hero-icon", { opacity: 1, scale: 1, ease: Back.easeOut.config(1.7), duration: 1 }, "-=0.25")
          .to(".block-hero .scroller", { opacity: 1, scale: 1, x: '-50%', y: '50%' }, "-=0.25")
          .to(".block-arguments", { opacity: 1, duration: 1 }, "-=0.75");
      }

      // .to(".block-hero .back-img-effect", { opacity: 0.60 })
      // .to(".block-hero .back-effect", { left: '100%', duration : 1 })
      // .to(".page-header", { opacity: 1, x: '0', y: '0' }, "-=0.25")

      scroll = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        offset: [0, 0],
        repeat: true,
        smoothMobile: true,
        getDirection: true
      });

      scroll.on('scroll', (instance) => {
        document.documentElement.setAttribute('data-direction', instance.direction)
      });
    }, 475)

    return true;

  };

  const refreshScroll = function() {
    scroll.update();

    setTimeout(() => {
      scroll.update();
    }, 1375);
  };

  // Expose public methods & properties
  return {
    init: init,
    refreshScroll: refreshScroll
  };

}());

site.GSAPAnims.init();
